// DOM-based juice effects, mounted into #stage. Mirrors prototype effects.

export function floatScore(container, { x, y, points, color }) {
  const el = document.createElement('div');
  el.className = 'float-score';
  el.style.left = x + 'px';
  el.style.top = y + 'px';
  el.style.color = color === 'gold' ? '#fde47a' : '#fff';
  el.textContent = '+' + points;
  container.appendChild(el);
  setTimeout(() => el.remove(), 950);
}

// Combo word escalates with chain length — leans into the cabaret/heat vibe.
//   ×5  STEAMY · ×10 HOT · ×15 ON FIRE · ×20 SCORCHING · ×25+ INSANE
const COMBO_WORDS = ['STEAMY', 'HOT', 'ON FIRE', 'SCORCHING', 'INSANE'];

export function comboPopup(container, n) {
  const existing = container.querySelector('.combo-popup');
  if (existing) existing.remove();
  const tierIdx = Math.max(0, Math.min(COMBO_WORDS.length - 1, Math.floor((n - 5) / 5)));
  const word = COMBO_WORDS[tierIdx];
  const el = document.createElement('div');
  el.className = 'combo-popup';
  el.textContent = `×${n} ${word}!`;
  // Tier ≥3 (ON FIRE+) — flip to gold glow for visual escalation.
  if (tierIdx >= 2) el.classList.add('hot');
  container.appendChild(el);
  setTimeout(() => el.remove(), 950);
}

export function stagePopup(container, stageName) {
  const existing = container.querySelector('.stage-unlock');
  if (existing) existing.remove();
  const el = document.createElement('div');
  el.className = 'stage-unlock';
  el.innerHTML = `<div class="badge"><div class="label">STAGE UNLOCKED</div><div class="name">${stageName}</div></div>`;
  container.appendChild(el);
  setTimeout(() => el.remove(), 1700);
}

export function feverBanner(container) {
  const existing = container.querySelector('.fever-banner');
  if (existing) existing.remove();
  const el = document.createElement('div');
  el.className = 'fever-banner';
  el.innerHTML = '<div class="text">FEVER!</div>';
  container.appendChild(el);
  setTimeout(() => el.remove(), 2600);
}

// 8-particle burst radiating outward — matches prototype spawnBurst.
export function particleBurst(container, sx, sy, color) {
  for (let i = 0; i < 8; i++) {
    const p = document.createElement('div');
    p.style.position = 'absolute';
    p.style.left = sx + 'px';
    p.style.top = sy + 'px';
    p.style.width = '5px';
    p.style.height = '5px';
    p.style.borderRadius = '50%';
    p.style.background = color;
    p.style.pointerEvents = 'none';
    p.style.boxShadow = `0 0 8px ${color}`;
    p.style.zIndex = '25';
    p.style.transition = 'transform .6s ease-out, opacity .6s';
    const angle = (Math.PI * 2 * i) / 8 + Math.random() * 0.5;
    const dist = 30 + Math.random() * 30;
    const dx = Math.cos(angle) * dist;
    const dy = Math.sin(angle) * dist;
    container.appendChild(p);
    requestAnimationFrame(() => {
      p.style.transform = `translate(${dx}px, ${dy}px) scale(.3)`;
      p.style.opacity = '0';
    });
    setTimeout(() => p.remove(), 650);
  }
}

export function shake(target) {
  target.classList.remove('shake');
  // force reflow to restart animation
  void target.offsetWidth;
  target.classList.add('shake');
  setTimeout(() => target.classList.remove('shake'), 260);
}
